export default "__VITE_ASSET__CsUQ6YOM__"